import { Select, Space, Typography } from "antd"
import Layout from "modules/layout/dashboard"

import styles from "./styles.module.scss"
import Loader from "components/loader"
import { useTranslation } from "react-i18next"
import { useMember } from "../../queries"
import { useToSubscribeActivities } from "./queries"
import { useMemberId } from "pages/member"
import { useSearchParams } from "react-router-dom"
import Search from "antd/es/input/Search"
import useOptions from "utils/use-options"
import { useExtSessions } from "../list/queries"
import ActivityItem from "./activityItem"
import { useEffect } from "react"

const { Title } = Typography
const { Main } = Layout
export const SESSION_PARAM = "session"

const Registration: React.FC = () => {
  const memberId = useMemberId()
  const member = useMember(memberId)
  const { t } = useTranslation()
  const sessions = useExtSessions({
    filter: {
      status: { values: ["published", "progress"], operator: "in" },
    },
  })

  const [searchParams, setSearchParams] = useSearchParams()

  const { data, isLoading } = useToSubscribeActivities(
    searchParams.get(SESSION_PARAM)!,
    undefined,
    { enabled: !!searchParams.get(SESSION_PARAM) }
  )

  const options = useOptions(data)

  const handleSessionFilter = (value: string) => {
    searchParams.set(SESSION_PARAM, value)
    setSearchParams(searchParams, { replace: true })
  }

  useEffect(() => {
    if (!searchParams.get(SESSION_PARAM) && sessions.data) {
      const currentSession =
        sessions.data.find((session) => session.status === "published") ||
        sessions.data.find((session) => session.status === "progress")
      currentSession && handleSessionFilter(currentSession.id)
    }
  }, [sessions.data, searchParams.get(SESSION_PARAM)])

  return (
    <>
      <Main.PageHeader
        breadcrumbs={[
          {
            title: member.data?.name,
            link: `/members/${member.data?.id}/events`,
          },
          {
            title: t("events.presubscriptions"),
          },
        ]}
        title={<Title level={3}> {t("events.presubscriptions")} </Title>}
        rightContent={
          <Space>
            <Select
              value={searchParams.get(SESSION_PARAM)}
              style={{ width: "100%" }}
              placeholder={t("global.select", {
                entity: t("events.session"),
                context: "female",
              })}
              loading={sessions.isLoading}
              onChange={handleSessionFilter}
              options={sessions.data?.map((session) => ({
                value: session.id,
                label: session.name,
              }))}
            />
            <Search
              value={options.search}
              onChange={(e) => {
                options.setSearch(e.target.value)
              }}
              placeholder={t("global.search")}
              style={{ width: "100%" }}
            />
          </Space>
        }
      />
      {isLoading || sessions.isLoading ? (
        <Loader />
      ) : (
        <div className={styles.cardsContainer}>
          {options?.options?.map((activity) => (
            <ActivityItem key={activity.id} activity={activity} />
          ))}
        </div>
      )}
    </>
  )
}

export default Registration
